import { render, staticRenderFns } from "./ModalLeaseTermEdit.vue?vue&type=template&id=2b13cc2e&"
import script from "./ModalLeaseTermEdit.vue?vue&type=script&lang=js&"
export * from "./ModalLeaseTermEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports